import React, { useState, useEffect, useContext, useRef } from 'react';
import {FormContext} from '@thinkwell/react.common';
import ReCAPTCHA from "react-google-recaptcha";

export default function ReCaptchaField(props) {
  const recaptchaRef = useRef();
  const form = useContext(FormContext)

  const validate = () => {
    const errors = [];
    const value = form.field('recaptcha')
    if (!value) {
      errors.push("Please verify the reCAPTCHA")
    }

    return errors
  }

  const onChange = (value) => {
    form.onData("recaptcha")(value)
  }

  form.register("recaptcha", validate)

  return <ReCAPTCHA ref={recaptchaRef} onChange={onChange} sitekey={props.siteSecret} />
  
}
